export const moduleConfig = {
    entityKey: 'productFeatures',
    titles: {
        singular: 'Product Feature',
        plural: 'Product Features'
    }
}

export const initialSortState = {
    column: 'created',
    direction: 'desc',
};